export default "__VITE_ASSET__0a43aeef__"